export const DATA_QUESTION_MOVING_NEXT_VERSION_3: Record<string, any> =
{
    '1st_recipient': {

        isStaff: [
            {
                nextKey: 'staffMemberName',
                condition: { isStaff: '1' }, // Staff → select staff member
            },
            {
                nextKey: 'recipientName',
                condition: { isStaff: '2' }, // Self/Care Recipient → jump to recipient info
            },
            {
                nextKey: 'fillerName',
                condition: { isStaff: '3' }, // Filling for client → collect filler info
            },
            {
                nextKey: 'referralName',
                condition: { isStaff: '4' }, // referral source for client → collect filler info
            },
        ],

        decisionMaker: 'recipientName',
        decisionMakerOther: 'recipientName',
        decisionMakerfollowUpQ: 'recipientName',
        relationship: 'recipientName',
        hasCallerEmail: 'recipientName',
        hasFillerEmail: 'recipientName',
        recipientAwareness: 'recipientName',
        reassessmentQuote: "patientCallingFor",
        patientCallingFor: [
            {
                nextKey: 'recipientName',
                condition: { patientCallingFor: '1' }, // Themselves → skip caller info
            },
            {
                nextKey: 'callerName',
                condition: { patientCallingFor: '2' }, // Someone else → collect caller info
            },
        ],


        hasRecipientEmail: 'source',
        hasRecipientEmailfollowUpQ: 'source',
        isRecipientDecisionMaker: 'source',
        isRecipientDecisionMakerfollowUpQ: 'source',
        isRecipientDecisionMakerOther: 'source',
        recipientPreferredContactMethod: 'source',


        hospitalName: 'serviceAddress',


        transfers: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' }, // 1 person physical assist
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' }, // 2 person physical assist
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' }, // needs lifting equipment
            },
            {
                nextKey: 'bathing',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],


        recipientWeight: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' },
            },
            {
                nextKey: 'bathing',
                condition: {},
            },
        ],


        transfersOther: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' },
            },
            {
                nextKey: 'bathing',
                condition: {},
            },
        ],
        transfersUncertain: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' },
            },
            {
                nextKey: 'bathing',
                condition: {},
            },
        ],
        falls: [
            {
                nextKey: 'injuries',
                condition: { falls: '2' }, // One fall in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '3' }, // Two or more falls in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '4' }, // Fall within the past 30 days
            },
            {
                nextKey: 'injuries',
                condition: { falls: '5' }, // Fall with injury
            },
            {
                nextKey: 'erVisits',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],
        fallsOther: [
            {
                nextKey: 'injuries',
                condition: { falls: '2' }, // One fall in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '3' }, // Two or more falls in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '4' }, // Fall within the past 30 days
            },
            {
                nextKey: 'injuries',
                condition: { falls: '5' }, // Fall with injury
            },
            {
                nextKey: 'erVisits',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],
        fallsUncertain: [
            {
                nextKey: 'injuries',
                condition: { falls: '2' }, // One fall in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '3' }, // Two or more falls in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '4' }, // Fall within the past 30 days
            },
            {
                nextKey: 'injuries',
                condition: { falls: '5' }, // Fall with injury
            },
            {
                nextKey: 'erVisits',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],
        petsInHome:[
             {
                nextKey: 'petSupportTasks',
                condition: { petsInHome: 'yes' }, 
            },
            {
                nextKey: 'transportation',
                condition: {  }, 
            },
            
        ],
        petSupportTasks:'transportation',
        petSafetyConcerns:'transportation',
        // Home Safety: Yes/Not sure → show the concern list below the property screen, otherwise skip it
        homeSafetyConcern: [
            {
                nextKey: 'homeSafetyConcernList',
                condition: { homeSafetyConcern: 'yes' },
            },
            {
                nextKey: 'homeSafetyConcernList',
                condition: { homeSafetyConcern: 'not_sure' },
            },
            {
                nextKey: 'paymentCategory',
                condition: {},
            },
        ],
        homeEnvironmentFinalNotes: [
            {
                nextKey: 'homeSafetyConcernList',
                condition: { homeSafetyConcern: 'yes' },
            },
            {
                nextKey: 'homeSafetyConcernList',
                condition: { homeSafetyConcern: 'not_sure' },
            },
            {
                nextKey: 'paymentCategory',
                condition: {},
            },
        ],
        primaryCarePhysicianName: [
            {
                nextKey: 'POAContactFullName', // Yes => show POA information
                condition: { emergencyContactDecisionMaker: '1' },
            },
            {
                nextKey: 'additionalNotes',// No => next additionalNotes question
                condition: { emergencyContactDecisionMaker: '2' },
            },
            {
                nextKey: 'POAContactDecisionMakerPerson', // Unsure => show POAContactDecisionMakerPerson question
                condition: { emergencyContactDecisionMaker: '3' },
            },
        ],
        emergencyContactDecisionMaker: [
            {
                nextKey: 'POAContactFullName', // Yes => show POA information
                condition: { emergencyContactDecisionMaker: '1' },
            },
            {
                nextKey: 'additionalNotes', // No => next additionalNotes question
                condition: { emergencyContactDecisionMaker: '2' },
            },
            {
                nextKey: 'POAContactDecisionMakerPerson', // Unsure => show POAContactDecisionMakerPerson question
                condition: { emergencyContactDecisionMaker: '3' },
            },
        ],
        POAContactDecisionMakerPerson: 'additionalNotes',
        POAContactAuthority: 'additionalNotes',
        hospitalAdmissions: [
            {
                nextKey: 'medicalConditions',
                condition: {
                    hospitalAdmissions: '1'
                }
            }
        ],
    },
    'full_care_2nd_recipient': {

        transfers: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' }, // 1 person physical assist
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' }, // 2 person physical assist
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' }, // needs lifting equipment
            },
            {
                nextKey: 'bathing',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],


        recipientWeight: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' },
            },
            {
                nextKey: 'bathing',
                condition: {},
            },
        ],


        transfersOther: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' },
            },
            {
                nextKey: 'bathing',
                condition: {},
            },
        ],
        transfersUncertain: [
            {
                nextKey: 'transferAssist',
                condition: { transfers: '3' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '4' },
            },
            {
                nextKey: 'transferAssist',
                condition: { transfers: '5' },
            },
            {
                nextKey: 'bathing',
                condition: {},
            },
        ],
        falls: [
            {
                nextKey: 'injuries',
                condition: { falls: '2' }, // One fall in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '3' }, // Two or more falls in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '4' }, // Fall within the past 30 days
            },
            {
                nextKey: 'injuries',
                condition: { falls: '5' }, // Fall with injury
            },
            {
                nextKey: 'erVisits',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],
        fallsOther: [
            {
                nextKey: 'injuries',
                condition: { falls: '2' }, // One fall in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '3' }, // Two or more falls in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '4' }, // Fall within the past 30 days
            },
            {
                nextKey: 'injuries',
                condition: { falls: '5' }, // Fall with injury
            },
            {
                nextKey: 'erVisits',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],
        fallsUncertain: [
            {
                nextKey: 'injuries',
                condition: { falls: '2' }, // One fall in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '3' }, // Two or more falls in the past 6 months
            },
            {
                nextKey: 'injuries',
                condition: { falls: '4' }, // Fall within the past 30 days
            },
            {
                nextKey: 'injuries',
                condition: { falls: '5' }, // Fall with injury
            },
            {
                nextKey: 'erVisits',            // independent / supervision / uncertain / OT → skip transferAssist
                condition: {},
            },
        ],
        housekeeping: 'transportation',
        primaryCarePhysicianName: [
            {
                nextKey: 'POAContactFullName', // Yes => show POA information
                condition: { emergencyContactDecisionMaker: '1' },
            },
            {
                nextKey: 'additionalNotes',// No => next additionalNotes question
                condition: { emergencyContactDecisionMaker: '2' },
            },
            {
                nextKey: 'POAContactDecisionMakerPerson', // Unsure => show POAContactDecisionMakerPerson question
                condition: { emergencyContactDecisionMaker: '3' },
            },
        ],
        emergencyContactDecisionMaker: [
            {
                nextKey: 'POAContactFullName', // Yes => show POA information
                condition: { emergencyContactDecisionMaker: '1' },
            },
            {
                nextKey: 'additionalNotes', // No => next additionalNotes question
                condition: { emergencyContactDecisionMaker: '2' },
            },
            {
                nextKey: 'POAContactDecisionMakerPerson', // Unsure => show POAContactDecisionMakerPerson question
                condition: { emergencyContactDecisionMaker: '3' },
            },
        ],
        POAContactDecisionMakerPerson: 'additionalNotes',
        POAContactAuthority: 'additionalNotes',
        hospitalAdmissions: [
            {
                nextKey: 'medicalConditions',
                condition: {
                    hospitalAdmissions: '1'
                }
            }
        ],
    }
};

// ─────────────────────────────────────────────────────────────────────────────
// BACK navigation — mirror of the forward branching rules above.
// Key  = current question the user is ON when they press Back.
// Value = question to return to (string) OR conditional array ({ condition, backKey }).
// Questions with no entry fall through to sequential (getBackNormalBackQuestion).
// ─────────────────────────────────────────────────────────────────────────────
export const DATA_QUESTION_MOVING_PREV_VERSION_3: Record<string, any> = {
    '1st_recipient': {
        fillerName: 'languagePreference',
        staffMemberName: 'languagePreference',
        referralName: 'languagePreference',
        callerName: 'reassessmentQuote',
        reassessmentQuote: 'isStaff',
        patientCallingFor: 'reassessmentQuote',
        recipientName: [
            {
                backKey: 'reassessmentQuote',
                condition: {
                    patientCallingFor: '1',
                },
            },
            {
                backKey: 'patientCallingFor',
                condition: {
                    patientCallingFor: '2',
                },
            },
            {
                backKey: 'languagePreference',
                condition: {
                    isStaff: '2',
                },
            },
            {
                backKey: 'isStaff',
                condition: {
                    isStaff: '3',
                },
            },
            {
                backKey: 'isStaff',
                condition: {
                    isStaff: '4',
                },
            },
        ],
        decisionMaker:
            [
                {
                    backKey: 'anyAdditionalPerson',
                    condition: {
                        anyAdditionalPerson: '1',
                    },
                },
                {
                    backKey: 'anyAdditionalPerson',
                    condition: {
                        anyAdditionalPerson: '0',
                    },
                },
            ],
        transferAssist: "assistiveDevices",
        bathing: 'transfers',
        erVisits: 'falls',
        propertyType: [
            {
                backKey: 'paymentCategory',
                condition: {
                    patientCallingFor: '2',
                },
            }, // or
            {
                backKey: 'paymentCategory',
                condition: {
                    isStaff: '3',
                },
            },
        ],

        source: [
            {
                backKey: 'isStaff',
                condition: {
                    isStaff: '2',
                },
            },
            {
                backKey: 'patientCallingFor',
                condition: {
                    patientCallingFor: '1',
                },
            },
            {
                backKey: 'recipientName',
                condition: {
                    patientCallingFor: '2',
                },
            },
            {
                backKey: 'recipientName',
                condition: {
                    isStaff: '3',
                },
            },
            {
                backKey: 'recipientName',
                condition: {
                    isStaff: '4',
                },
            },
        ],
        transportation:'petsInHome',
        paymentCategory: 'homeSafetyConcern',
        additionalNotes: 'primaryCarePhysicianName',
        medicalConditions: [{
            backKey: 'hospitalAdmissions',
            condition: {
                hospitalAdmissions: '1',
            },
        }],
    },
    'full_care_2nd_recipient': {
        transportation: 'housekeeping',
        transferAssist: "assistiveDevices",
        bathing: 'transfers',
        propertyType: [
            {
                backKey: 'paymentCategory',
                condition: {
                    patientCallingFor: '2',
                },
            }, // or
            {
                backKey: 'paymentCategory',
                condition: {
                    isStaff: '3',
                },
            },
        ],
        additionalNotes: 'primaryCarePhysicianName',
        erVisits: 'falls',
        medicalConditions: [{
            backKey: 'hospitalAdmissions',
            condition: {
                hospitalAdmissions: '1',
            },
        }],

    }
};
export const DATA_BACK_ON_QUESTION_KEY_VERSION_3: Record<string, any> = {
    'fillerName': "isStaff",
    'fillerPhoneNumber': "isStaff",
    'hasFillerEmail': "isStaff",
    'referralName': "isStaff",
    "referralPhoneNumber": "isStaff",
    "referralEmail": "isStaff",
    'organizationName': "isStaff",
    "yourRole": "isStaff",
    'relationship': [
        {
            "key": "isStaff",
            "condition": {
                "isStaff": 3
            }
        },
        {
            "key": 'patientCallingFor',
            condition: {
                patientCallingFor: '2',
            },
        },
    ],
    'isRecipientDecisionMaker': "isStaff",
    'recipientAwareness': "isStaff",
    'decisionMaker': [
        {
            "key": "isStaff",
            "condition": {
                "isStaff": 3
            }
        },
        {
            "key": "isStaff",
            "condition": {
                "isStaff": 4
            }
        },
        {
            "key": 'patientCallingFor',
            condition: {
                patientCallingFor: '2',
            },
        },
    ],
    'staffMemberName': 'isStaff',
    'referralSourceName': 'isStaff',
    'recipientName': [{
        "key": "isStaff",
        "condition": {
            "isStaff": 2
        }
    },
    {
        "key": 'patientCallingFor',
        condition: {
            patientCallingFor: '1',
        },
    }
    ],
    'recipientPhoneNumber': [
        {
            "key": "isStaff",
            "condition": {
                "isStaff": 2
            }
        },

        {
            "key": 'patientCallingFor',
            condition: {
                patientCallingFor: '1',
            },
        }
    ],
    'recipientGender':
        [{
            "key": "isStaff",
            "condition": {
                "isStaff": 2
            }
        },
        {
            "key": 'patientCallingFor',
            condition: {
                patientCallingFor: '1',
            },
        }
        ],
    'recipientDob': [
        {
            "key": "isStaff",
            "condition": {
                "isStaff": 2
            }
        },

        {
            "key": 'patientCallingFor',
            condition: {
                patientCallingFor: '1',
            },
        }],
    'hasRecipientEmail': [{
        "key": "isStaff",
        "condition": {
            "isStaff": 2
        },

    },

    {
        "key": 'patientCallingFor',
        condition: {
            patientCallingFor: '1',
        },
    }],
    "callerName": "patientCallingFor",
    "callerPhoneNumber": "patientCallingFor",
    "hasCallerEmail": "patientCallingFor",
    'transferAssist': "transfers",
    'injuries': "falls",
    'contactTimeDate': "readyToScheduleHomeAppt",
    'anyAdditionalInfo': "readyToScheduleHomeAppt",
    'petSupportTasks':'petsInHome',
    'petSafetyConcerns':'petsInHome',
    'homeSafetyConcernList': 'homeSafetyConcern',
    'POAContactFullName': "emergencyContactDecisionMaker",
    'POAContactRelationship': "emergencyContactDecisionMaker",
    'POAContactEmail': "emergencyContactDecisionMaker",
    'POAContactAuthority': "emergencyContactDecisionMaker",
    'POAContactDecisionMakerPerson': "emergencyContactDecisionMaker",
};
export const DATA_QUESTION_REMOVE_VERSION_3: Record<string, any> = {
    isStaff: {
        '1': [
            'fillerName',
            'fillerPhoneNumber',
            'hasFillerEmail',
            'recipientAwareness',
            'relationship',
            'referralName',
            'referralPhoneNumber',
            'referralEmail',
            'organizationName',
            'yourRole',
            'isRecipientDecisionMaker',
        ],
        '2': [
            'staffMemberName',
            'patientCallingFor',
            'referralSourceName',
            'callerName',
            'callerPhoneNumber',
            'hasCallerEmail',
            'fillerName',
            'fillerPhoneNumber',
            'hasFillerEmail',
            'relationship',
            "reassessmentQuote",
            'referralName',
            'referralPhoneNumber',
            'referralEmail',
            'organizationName',
            'yourRole',
            'recipientAwareness',
            'decisionMaker',
        ],
        '3': [
            'staffMemberName',
            'patientCallingFor',
            'referralSourceName',
            'callerName',
            'callerPhoneNumber',
            'hasCallerEmail',
            'referralSourceName',
            "reassessmentQuote",
            'referralName',
            'referralPhoneNumber',
            'referralEmail',
            'organizationName',
            'yourRole',
            'isRecipientDecisionMaker',
        ],
        '4': [
            'staffMemberName',
            'patientCallingFor',
            'referralSourceName',
            'callerName',
            'callerPhoneNumber',
            'hasCallerEmail',
            'fillerName',
            'fillerPhoneNumber',
            'hasFillerEmail',
            'relationship',
            "reassessmentQuote",
            'isRecipientDecisionMaker',
            'recipientAwareness',
        ]
    },
    patientCallingFor: {
        '1': [
            'callerName',
            'callerPhoneNumber',
            'hasCallerEmail',
            'relationship',
            'decisionMaker',
        ],
    },
    gatedCommunity: {
        '2': ['gatedCommunityOther'],
    },
    transfers: {
        "1": ["transferAssist"],
        "2": ["transferAssist"],
        "@UN": ["transferAssist"],
        "OT": ["transferAssist"]
    },
    falls: {
        '1': ["injuries"],
        "@UN": ["injuries"],
        "OT": ["injuries"]
    },
    petsInHome: {
        'no': ['petSupportTasks', 'petSafetyConcerns'],
        '@UN': ['petSupportTasks', 'petSafetyConcerns'],
    },
    homeSafetyConcern: {
        'no': ['homeSafetyConcernList'],
    },
    emergencyContactDecisionMaker: {
        "1": ['POAContactDecisionMakerPerson'],
        "2": [
            "POAContactDecisionMakerPerson",
            "POAContactFullName",
            "POAContactRelationship",
            "POAContactPhoneNumber",
            "POAContactEmail",
            "POAContactAuthority"
        ],
        "3": [
            "POAContactFullName",
            "POAContactRelationship",
            "POAContactPhoneNumber",
            "POAContactEmail",
            "POAContactAuthority"
        ],
    }

};
export const autoFillCondition: Record<string, any> = {
    // 1. Task: Hospital/Rehab Status Sync 
    "currentlyInHospitalOrRehab": {
        "condition": {
            "includes": ["1"]
        },
        "targets": {
            "hospitalAdmissions": "5"
        },
        "followUpMapping": {
            "diagnosis_reason": "hospital_admission_reason",
        }
    },
    // // 2. Task: Oxygen Usage Sync
    // "oxygen_in_home": {
    //     "condition": {
    //         "includes": ["yes"]
    //     },
    //     "targets": {
    //         "treatments": ["oxygen_assist"],
    //         "medicalConditions": ["oxygen_use"]
    //     }
    // },

    // // 3. Task: Clinical Tasks Sync (Oxygen & Diabetes)
    // "medicalConditions": [
    //     {
    //         "condition": {
    //             "includes": ["6"]
    //         },
    //         "targets": {
    //             "treatments": ["blood_sugar", "3"]
    //         }
    //     },
    //     {
    //         "condition": {
    //             "includes": ["oxygen_use"]
    //         },
    //         "targets": {
    //             "oxygen_in_home": "yes",
    //             "treatments": ["oxygen_assist"],
    //         }
    //     },
    //     {
    //         "condition": {
    //             "includes": ["5", "confusion", "alzheimers"]
    //         },
    //         "targets": {
    //             "companion": ["supervision_memory", "wandering_concern"]
    //         }
    //     },
    // ],
    // "falls": [
    //     {
    //         "condition": {
    //             "includes": ["2"]
    //         },
    //         "targets": {
    //             "hospitalAdmissions": "2",
    //             "erVisits": "2"
    //         },
    //         "hardcodeFollowUps": {
    //             "erVisits": {
    //                 "er_visit_reason": ["fall"]
    //             }
    //         }
    //     },
    //     {
    //         "condition": {
    //             "includes": [3]
    //         },
    //         "targets": {
    //             "hospitalAdmissions": "3",
    //             "erVisits": "4"
    //         },
    //         "hardcodeFollowUps": {
    //             "erVisits": {
    //                 "er_visit_reason": ["fall"]
    //             }
    //         }
    //     },
    //     {
    //         "condition": {
    //             "includes": [4]
    //         },
    //         "targets": {
    //             "hospitalAdmissions": "4",
    //             "erVisits": "5"
    //         },
    //         "hardcodeFollowUps": {
    //             "erVisits": {
    //                 "er_visit_reason": ["fall"]
    //             }
    //         }
    //     }
    // ],
    // // "toileting": {
    // //     "condition": {
    // //         "includes": ["5"]
    // //     },
    // //     "targets": {
    // //         "treatments": ["catheter_routine", "ostomy_routine"]
    // //     }
    // // },
    // "ambulation": [
    //     {
    //         "condition": {
    //             "includes": ["5"]
    //         },
    //         "targets": {
    //             "transfers": "5",
    //             "assistiveDevices": ["6", "5"],
    //             "toileting": "5"
    //         }
    //     }
    // ],
    // "incontinent":[
    //     {
    //         "condition": {
    //             "includes": ["4"],
    //             "dependencies": { 
    //                 "ambulation": ["5"]
    //             }
    //         },
    //         "targets": {
    //             "skinBreakdown": ["2"]
    //         }
    //     },
    // ]

    // "hospitalAdmissions": {
    //     "condition": {
    //         "includes": ["1"]
    //     },
    //     "targets": {
    //         "ICUHistory": "no_icu"
    //     }
    // }
};
export const autofillPerson2QuestionKeys = ['petsInHome', 'petSupportTasks', 'petSafetyConcerns', 'oxygen_in_home']
// HP-2 / TRM 7.1 shared household facts: answered once by Person 1, shown to Person 2 already answered and read-only
export const householdFactsFromPerson1 = ['oxygen_in_home'];
export const questionKeysFillPerson2 = ['servicesProvided', 'daysRequiredService', 'hoursNeededPreferred', 'medicalDecisionMaker', 'financialDecisionMaker', 'primaryCoordinator', 'primaryEmergencyContact', 'currentHelpers', 'transportation'];
